import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {NavigationExtras, Params, Router, Event} from '@angular/router';
import {Store} from '@ngxs/store';
import {Navigate} from '@ngxs/router-plugin';
import {Observable} from 'rxjs';
import {isPlatformServer} from '@angular/common';
import {DOCUMENT} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {

  constructor(private store: Store, private router: Router, @Inject(PLATFORM_ID) private platformId: any,
              @Inject(DOCUMENT) private document: any) {
  }

  getRouterEvents(): Observable<Event> {
    return this.router.events;
  }

  getCurrentUrl(): string {
    return this.router.url;
  }

  getHost(): string {
    if (isPlatformServer(this.platformId)) {
      return this.document.location.host;
    }
    return window.location.host;
  }

  navigateHome(): Observable<any> {
    return this.store.dispatch(new Navigate(['/dashboard']));
  }

  navigateLogin(args?: any): Observable<any> {
    return this.store.dispatch(new Navigate(['/login'], {
      ...args
    }, {
      queryParamsHandling: 'merge'
    }));
  }

  decodeAndNavigateToPath(path: string) {
    const regex = /[?&]([^=#]+)=([^&#]*)/g;
    const params = {};
    let match;
    // tslint:disable-next-line:no-conditional-assignment
    while (match = regex.exec(path)) {
      params[match[1]] = match[2];
    }
    if (path) {
      path = path.split('?')[0];
      if (path.includes('http') && path.includes('://')) {
        // Remove http:// or https:// and the domain.com
        path = path.replace(/^.*\/\/[^/]+/, '');
      }
      return this.navigateToPath([path], params);
    }
    return this.navigateHome();
  }

  navigateToPath(path: string[], query?: Params | undefined, extras?: NavigationExtras) {
    return this.store.dispatch(new Navigate(path, query, extras));
  }
}
